export default {
  complexityParameters: [],
  energySourceUnitConversions: [],
  gridEfficiencyTemplates: []
}
